import config from "@/config";
import { CloudProjectType, PostCloudProjectResponse, SaveCloudProjectRequest } from "./types/cloud";
import Axios, { AxiosSilent } from "@/utils/Axios";
import { BaseResponse } from "@/types/base";

const CloudProjectApis = {
  switch: "/cloud/set_using",
  save: "/v2/cloud/save",
  list: "/cloud/list",
  detail: "/cloud/detail",
  delete: "/cloud/delete",
  latest: "/cloud/latest",
};

/**
 * @TODO 加一个覆盖云端的参数
 * @param data
 * @returns
 */
export const postSaveCloudProject = (data: {
  id: string;
  name: string;
  cloudCacheJson: string;
  commitId?: string;
  preview?: string;
  isOverwrite?: boolean;
}) => {
  const body: SaveCloudProjectRequest = { project_id: data.id };
  if (data.name) {
    body.project_name = data.name;
  }
  if (data.cloudCacheJson) {
    body.content = data.cloudCacheJson;
  }
  if (data.commitId) {
    body.commit_id = data.commitId;
  }
  if (data.preview) {
    body.preview = data.preview;
  }
  if (data.isOverwrite) {
    body.is_overwrite = data.isOverwrite;
  }
  return Axios.post<SaveCloudProjectRequest, PostCloudProjectResponse>(
    CloudProjectApis.save,
    body,
    {},
    config.creatorUrl,
  ).then((res: any) => {
    return res;
  });
};

export const postSwitchCloudProject = (projectId: string) => {
  return Axios.post(CloudProjectApis.switch, { project_id: projectId }, {}, config.creatorUrl);
};

export function postDeleteCloudProject(projectId: string) {
  return Axios.post(CloudProjectApis.delete, { project_id: projectId }, {}, config.creatorUrl);
}

export async function getCloudProjects(
  pageIndex = 1,
  pageSize = 10,
  commitId = "",
): Promise<BaseResponse<{ total: number; projects: CloudProjectType[] }> | undefined> {
  return Axios.get(
    CloudProjectApis.list,
    { page_index: pageIndex, page_size: pageSize, commit_id: commitId ?? "" },
    {},
    config.creatorUrl,
  );
}

export async function getProjectLatest(projectId: string) {
  return AxiosSilent.get<
    { project_id: string },
    BaseResponse<{
      project: CloudProjectType;
    }>
  >(CloudProjectApis.latest, { project_id: projectId }, {}, config.creatorUrl);
}

export async function getProjectDetail(projectId: string) {
  return Axios.get<
    { project_id: string },
    BaseResponse<{
      project: CloudProjectType;
      versions: CloudProjectType[] | null;
    }>
  >(CloudProjectApis.detail, { project_id: projectId }, {}, config.creatorUrl);
}
